import { cloneDeep } from "lodash";
import {
  ADD_CROSS_SECTIONAL_AREA_STARTING,
  ADD_CROSS_SECTIONAL_AREA_SUCCESS,
  ADD_CROSS_SECTIONAL_AREA_ERROR,
} from "../../../constants/actionTypes";
import initialState from "../../../store/initialState";

export default function addCrossSectionalAreaReducer(
  state = initialState.addCrossSectionalArea,
  action
) {
  switch (action.type) {
    case ADD_CROSS_SECTIONAL_AREA_STARTING: {
      const newState = cloneDeep(state);
      newState.saving = true;
      newState.saved = false;
      return newState;
    }

    case ADD_CROSS_SECTIONAL_AREA_SUCCESS: {
      const { data } = action;
      const newState = cloneDeep(state);
      newState.saving = false;
      newState.saved = true;
      newState.error = null;

      newState.newCrossSectionalArea = data.crossSectionalAreas;
      return newState;
    }

    case ADD_CROSS_SECTIONAL_AREA_ERROR: {
      const newState = cloneDeep(state);
      newState.saving = false;
      newState.saved = false;
      newState.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
